module.exports = __webpack_public_path__ + "static/media/small-delete-button.d7fc9d56.svg";